import { OrderByDirection } from 'firebase/firestore';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CurrencyExchangeRateFirestoreService } from './currency-exchange-rates-firestore.service';
import { ICurrencyExchangeRate } from '@simplyfly/shared';
import { format } from 'date-fns';
import { IFindCondition } from '../firestore/firestore.service';

@Injectable({
  providedIn: 'root'
})
export class CurrencyExchangeRateService {
  constructor(private currencyExchangeRateFirestoreService: CurrencyExchangeRateFirestoreService) {}

  create(currencyExchangeRate: ICurrencyExchangeRate): Promise<string> {
    return this.currencyExchangeRateFirestoreService.create(currencyExchangeRate);
  }

  createWithId(id: string, currencyExchangeRate: ICurrencyExchangeRate): Promise<string> {
    return this.currencyExchangeRateFirestoreService.createWithId(id, currencyExchangeRate);
  }

  update(currencyExchangeRate: ICurrencyExchangeRate): Promise<string> {
    return this.currencyExchangeRateFirestoreService.update(currencyExchangeRate);
  }

  delete(id: string): Promise<void> {
    return this.currencyExchangeRateFirestoreService.delete(id);
  }

  getFromId(id: string): Observable<ICurrencyExchangeRate> {
    return this.currencyExchangeRateFirestoreService.docValue$(id);
  }

  getAll(): Observable<ICurrencyExchangeRate[]> {
    return this.currencyExchangeRateFirestoreService.collectionValues$();
  }

  getToday(): Observable<ICurrencyExchangeRate> {
    const id: string = format(new Date(), 'yyyy-MM-dd');

    return this.currencyExchangeRateFirestoreService.docValue$(id);
  }

  resetPagination(paginationName: string = 'list'): void {
    this.currencyExchangeRateFirestoreService.resetPaginate(paginationName);
  }

  getPaginatedResult(
    paginationName: string = 'list',
    conditions: IFindCondition[] = [],
    orderBy: {
      field: string;
      direction: OrderByDirection;
    } = {
      field: 'created',
      direction: 'desc'
    },
    itemsPerPage: number = 20,
    direction: 'prev' | 'next' = 'next'
  ): Observable<ICurrencyExchangeRate[]> {
    return this.currencyExchangeRateFirestoreService.paginate(
      conditions,
      orderBy,
      itemsPerPage,
      paginationName,
      direction
    );
  }
}
